var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("date-picker", {
        ref: "datePicker",
        attrs: {
          disabled: _vm.disabled,
          "disabled-date": _vm.maxDate,
          format: "DD/MMMM/YYYY",
          inline: true,
          lang: _vm.lang,
          "title-format": "MMMM/YYYY",
          type: _vm.calendarType,
          "value-type": "date"
        },
        on: { input: _vm.sendValue },
        model: {
          value: _vm.value,
          callback: function($$v) {
            _vm.value = $$v
          },
          expression: "value"
        }
      }),
      _vm.error
        ? _c("p", { staticClass: "error" }, [
            _c("em", { staticClass: "fa fa-times-circle" }),
            _c("span", [_vm._v(_vm._s(_vm.customErrorMsg))])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }